// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";

// Components Imports
import ToolPaneList from "./ToolPaneList";
import ToolPaneActiveView from "./ToolPaneActiveView";

// Internal Imports
import { DOCUMENTS, PIPELINE, TOOLPANE, COMMON } from "../../constants";

// Actions Imports
import { QuotationActions } from "../../actions";

// Destructuring
const { updateToolPaneData } = QuotationActions;
const { DOCUMENT_STATUS_HASMAP } = PIPELINE;
const { DOCUMENT_MODE } = DOCUMENTS;
const { TOOLPANE_TTITLE } = TOOLPANE;
const { TABLE_TYPE } = COMMON;

// Declaration
const TEMPLATE = "TEMPLATE";
const DOCUMENT = "DOCUMENT";
const FORM = "FORM";

class ToolPaneWrapper extends Component {
  componentDidMount = () => {
    const { isLocked, showForm, currentTabView, isPdfDocument, documentNotes } =
      this.props;
    // On Component mount, pass the page info to the toolpane wrapper
    if (this.props.mode !== TEMPLATE && !isLocked && showForm === false) {
      if (isPdfDocument) {
        this.props.updateToolPaneData(
          true,
          TOOLPANE_TTITLE.SIGNATURE_COMPONENTS,
          "PDF_DOCUMENT",
        );
      } else {
        this.props.updateToolPaneData(
          true,
          TOOLPANE_TTITLE.DOC_COMPONENTS,
          currentTabView,
        );
      }
    } else if (
      this.props.mode === TEMPLATE &&
      !this.props.isPdfDocument &&
      this.props.templateStatus === "DRAFT" &&
      !(this.props.view && this.props.isOpen)
    ) {
      this.props.updateToolPaneData(true, "doc-components", "TEMPLATE");
    } else if (this.props.isSharedDocument) {
      if (
        window.location &&
        window.location.pathname &&
        window.location.pathname.includes("shared") &&
        documentNotes &&
        Array.isArray(documentNotes) &&
        documentNotes.length > 0 &&
        window.innerWidth > 600 &&
        !this.props.isLz &&
        !(
          window.location.pathname.includes("/perma/DOC/") ||
          window.location.pathname.includes("/m/") ||
          window.location.pathname.includes("/s/") ||
          window.location.pathname.includes("/f/")
        )
      ) {
        this.props.updateToolPaneData(
          true,
          TOOLPANE_TTITLE.NOTES,
          currentTabView,
        );
      }
      // add code
    } else {
      this.props.updateToolPaneData(false, "", currentTabView);
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    /**
     * Reset the toolPane view to default when toggling between
     * lock and edit mode in document.
     */
    if (this.props.isLocked !== nextProps.isLocked) {
      let pageName = "";
      if (this.props.isPdfDocument) {
        pageName =
          this.props.mode === DOCUMENT_MODE.DOCUMENT
            ? "PDF_DOCUMENT"
            : "PDF_TEMPLATE";
      }

      this.props.updateToolPaneData(false, "", pageName);
    }
  }

  render() {
    const {
      isOpen,
      page,
      view,
      isSharedDocument,
      templateStatus,
      documentPageType,
    } = this.props;

    let showToolbar = page === TABLE_TYPE.EXTERNAL_API ? false : !!page;
    if (isSharedDocument) {
      showToolbar = isOpen;
    }

    if (templateStatus && templateStatus !== "DRAFT") {
      showToolbar = false;
    }

    if (showToolbar) {
      return (
        <div className={`toolpanewrapper ${isOpen ? "is-open" : ""}`}>
          {/* -------- Active tooplane view section -------- */}
          {isOpen && documentPageType !== "PERMA_SHARED_DOCUMENT" && (
            <div className={`toolpanewrapper-content ${view}`}>
              <ToolPaneActiveView
                coverpageThemeActionData={this.props.coverpageThemeActionData}
                disableEdit={this.props.disableEdit}
                isSharedDocument={this.props.isSharedDocument}
                mode={this.props.mode}
                sharingHash={this.props.sharingHash}
                signatureWrapperRef={this.props.signatureWrapperRef}
                view={this.props.view}
                templateLockStatus={this.props.templateLockStatus}
              />
            </div>
          )}
          {/* -------- Tooplane list section -------- */}
          <div
            className={`toolpanewrapper-options ${
              isSharedDocument ? "shareddocument-toolpanewrapper-options" : ""
            }`}>
            {!isSharedDocument ? (
              <ToolPaneList
                foundSignatureBlockStatus={this.props.foundSignatureBlockStatus}
                templateStatus={templateStatus}
                mode={this.props.mode}
                isOpen={isOpen}
                view={view}
                page={page}
              />
            ) : null}
          </div>
        </div>
      );
    }
    return <div />;
  }
}

const mapStateToProps = (state, props) => {
  const { mode } = props;
  const { isOpen, page, view } = state.ToolPaneStore;
  const { documentNotes } = state.NotesStore;
  const {
    document: { isLocked, stage, isPdfDocument, showForm } = {},
    content,
  } = state.DocumentStore;
  const { is_lz: isLz } = state.SharedDocument;
  let isTemplateTypeForm = false;
  let isDocumentLocked = false;
  let coverpageThemeActionData = null;
  if (mode === DOCUMENT) {
    const {
      coverpageThemeActionLabel,
      document: { template_type: typeOfTemplate, scope } = {},
    } = state.DocumentStore;
    isTemplateTypeForm =
      typeOfTemplate && typeOfTemplate.toUpperCase() === FORM;
    isDocumentLocked =
      !(scope && scope.write) || stage !== DOCUMENT_STATUS_HASMAP.DRAFT;
    coverpageThemeActionData = coverpageThemeActionLabel;
  } else if (mode === TEMPLATE) {
    const {
      coverpageThemeActionLabel,
      template: { template_type: typeOfTemplate, status },
    } = state.TemplateStore;
    coverpageThemeActionData = coverpageThemeActionLabel;
    isTemplateTypeForm =
      typeOfTemplate && typeOfTemplate.toUpperCase() === FORM;
    isDocumentLocked = isLocked || status !== DOCUMENT_STATUS_HASMAP.DRAFT;
  }
  /* This code is responsible for handling Dynamic field with Signature */
  let foundSignatureBlockStatus;
  if (content && content.sections && content.sections.length > 0) {
    const found = content.sections.find(
      element => element.type === "Signature",
    );
    if (found && showForm && stage === "DRAFT") {
      foundSignatureBlockStatus = true;
    }
  }
  let templateLockStatus = false;
  let templateStatus;
  if (mode === TEMPLATE) {
    const { template } = state.TemplateStore;
    templateStatus = template.status;
    templateLockStatus = templateStatus !== "DRAFT";
  }
  const disableEdit = isDocumentLocked || (isTemplateTypeForm && showForm);
  const { view: currentTabView } = state.QuotationStore;
  return {
    showForm,
    isLocked,
    isOpen,
    page,
    view,
    templateStatus,
    templateLockStatus,
    foundSignatureBlockStatus,
    isPdfDocument,
    coverpageThemeActionData,
    disableEdit,
    currentTabView,
    documentNotes,
    isLz,
  };
};

const mapDispatchToProps = {
  updateToolPaneData,
};

export default connect(mapStateToProps, mapDispatchToProps)(ToolPaneWrapper);
